<template>
    <div class="scan_detail_">
        <div class="scan_detail_header">基础信息</div>
        <div class="scan_detail_main">
            <div class="scan_row">
                <div class="scan_row_text">设备名称：</div>
                <div class="scan_row_data">{{devicesInfo&&devicesInfo.bigDeviceName}}</div>
            </div>
            <div class="scan_row">
                <div class="scan_row_text">规格型号：</div>
                <div class="scan_row_data">{{devicesInfo&&devicesInfo.bigDeviceModel}}</div>
            </div>
            <div class="scan_row">
                <div class="scan_row_text">设备编号：</div>
                <div class="scan_row_data">{{devicesInfo&&devicesInfo.bigNumber}}</div>
            </div>
            <div class="scan_row">
                <div class="scan_row_text">设备类型：</div>
                <div class="scan_row_data">{{devicesInfo&&devicesInfo.bigTypeName}}</div>
            </div>
            <div class="scan_row">
                <div class="scan_row_text">安装位置：</div>
                <div class="scan_row_data">{{devicesInfo&&devicesInfo.bigPosition}}</div>
            </div>
            <div class="scan_row">
                <div class="scan_row_text">设备状态：</div>
                <div class="scan_row_data">{{devicesInfo&&devicesInfo.bigState===1?'在线':'离线'}}</div>
            </div>
            <div class="scan_row">
                <div class="scan_row_text">责任人：</div>
                <div class="scan_row_data">{{devicesInfo&&devicesInfo.realName===null?'':devicesInfo.realName}}</div>
            </div>
            <div class="scan_row">
                <div class="scan_row_text">供应商：</div>
                <div class="scan_row_data">{{devicesInfo&&devicesInfo.supplierName}}</div>
            </div>
            <div class="scan_row">
                <div class="scan_row_text">钥匙柜编号：</div>
                <div class="scan_row_data">{{devicesInfo&&devicesInfo.keyCabinet}}</div>
            </div>
            <div class="scan_row">
                <div class="scan_row_text">使用年限：</div>
                <div class="scan_row_data">{{devicesInfo&&devicesInfo.useLife}}</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            devicesInfo:[],//大型生产设备信息
            url:null,//传参
        }
    },
    mounted(){
        this.getDeviceInnfo()
    },
    methods:{
        //获取设备信息
        getDeviceInnfo(){
            this.url = window.location.href.split('?')[1].split('=')[1]
            window.document.title="大型生产设备"
            this.$api.Device.detailsBigDevice({bigDeviceId:this.url}).then(res=>{
                if(res.statusMsg === 'ok'){
                    this.devicesInfo = res.data
                }else{
                    this.$message.warnning(res.statusMsg)
                }
            })
        }
    }
}
</script>
<style scoped lang="scss">
.scan_detail_{
    width: 100%;
    height: 100%;
    padding: 10px 20px;
    display: flex;
    flex-direction: column;
    background-color: #0C264A;

    .scan_detail_header{
        height: 50px;
        color: rgba(255,255,255,.88);
        font-size: 16px;
        font-weight: bold;
        display: flex;
        justify-content: center;
        align-items: center;
        background:url("../../assets/scan/scan_header_bg.png") no-repeat;
        background-size: 100% 100%;
        background-position: center;
    }
    .scan_detail_main{
        margin-top: 10px;

        .scan_row{
            display: flex;
            background: url("../../assets/scan/scan_main_rowbg.png") no-repeat;
            background-size: 100% 100%;
            margin-top: 10px;
            padding: 10px 15px;
            .scan_row_text{
                font-size: 15px;
                flex: none;
                color: rgba(255,255,255,.72);
            }
            .scan_row_data{
                font-size: 15px;
                flex: 1;
                color: #3DC8FF;
            }
        }
    }
}
</style>